import React, {VoidFunctionComponent} from 'react';
import {useIntl} from 'react-intl';
import FilterGroup from '../filter-group/filter-group';

import styles from './filter-panel.module.css';

const FilterPanel: VoidFunctionComponent = () => {
  const {formatMessage} = useIntl();

  const translatedYearsTitle = formatMessage({id: 'work.filter.title.years'});
  const translatedCategoryTitle = formatMessage({
    id: 'work.filter.title.categories'
  });
  const translatedTagsTitle = formatMessage({
    id: 'work.filter.title.tags'
  });

  return (
    <div className={styles.filterPanel}>
      <FilterGroup title={translatedYearsTitle} filterGroupCategory="year" />
      <FilterGroup
        title={translatedCategoryTitle}
        filterGroupCategory="categories"
      />
      <FilterGroup title={translatedTagsTitle} filterGroupCategory="tags" />
    </div>
  );
};

export default FilterPanel;
